import React from 'react'
import { TimelineItemContentBadgeTypeT } from 'components/Timeline/types'
import Avatar from 'redesign/components/molecules/Avatar'
import IconAndTextBlock from 'redesign/components/molecules/IconAndTextBlock'
import TimelineBadge from 'redesign/components/molecules/timeline-badge'
import { getIsAvatarWithIcon } from './get-is-avatar-with-icon'
import { BadgeContainer, Container } from './styles'
import TimelineElementBody from './timeline-element-body'
import type { TimelineElementProps } from './types'

const TimelineElement: React.FC<TimelineElementProps> = ({
  avatar,
  badgeProps,
  title,
  children,
  comment,
  reminder,
  dateFrom,
  dateTo,
  singleDay,
  dayTime,
  absenceType,
  dates,
  badge,
}) => {
  const { reminder: reminderText, boldText } = reminder ?? {}
  const displayAvatar = avatar && getIsAvatarWithIcon(avatar)
  const absenceText = singleDay ? dayTime : absenceType
  const showTimelineTime = Boolean(absenceText)
  const showDates = Boolean(dates) && badge === TimelineItemContentBadgeTypeT.absenceRequestAccepted
  const showAvatar = badge !== TimelineItemContentBadgeTypeT.automatedReminder

  return (
    <Container>
      {badgeProps && (
        <BadgeContainer>
          <TimelineBadge {...badgeProps} tooltipPlacement="top" />
        </BadgeContainer>
      )}
      {showAvatar && (
        <IconAndTextBlock
          icon={displayAvatar ? <Avatar src={avatar.avatarUrl} text={avatar.avatarName} /> : undefined}
          overflowSingleLine
          title={title}
          variant="body2"
        />
      )}
      <TimelineElementBody
        dates={dates}
        dateFrom={dateFrom}
        dateTo={dateTo}
        showDates={showDates}
        showTimelineTime={showTimelineTime}
        comment={comment}
        absenceText={absenceText}
        reminder={reminderText}
        boldText={boldText}
      >
        {children}
      </TimelineElementBody>
    </Container>
  )
}

export default TimelineElement
